import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=195a8bc2"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports